import { Store } from 'utils';

class OverlayStore extends Store {

	getInitialState() {
		return {
			visible: []
		}
	}

	onOverlayChanged(state, data) {
		if(data.visible) {
			state.visible = state.visible.concat([data.name]);
		} else {
			state.visible = state.visible.filter(item => item != data.name);
		}
	}

	onPrizeChanged(state) {
		this.onOverlayChanged(state, {
			name: 'nagrada',
			visible: true
		})
	}

	isVisible(name) {
		return this.getState().visible.includes(name);
	}

}

const store = new OverlayStore();
export default store;


// WEBPACK FOOTER //
// ./src/modules/model/overlaystore.js